import { ArrowUpRight } from "lucide-react";
import { PROFILE } from "../../../lib/data";

export const CaseMiniFooter = () => (
  <footer className="bg-[var(--ink)] text-[var(--paper)]">
    <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-10 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[10.5px] tracking-[0.22em] uppercase">
      <p className="opacity-70">
        Yash Kankaria · Building businesses through memorable brands.
      </p>
      <a
        href={`mailto:${PROFILE.email}`}
        className="hover:opacity-60 inline-flex items-center gap-1"
      >
        {PROFILE.email}
        <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
      </a>
    </div>
  </footer>
);
